import { GalleryPageProps } from './gallery-page.type';
import styles from './gallery-page.module.css';
import { GalleryItem } from '../gallery-item/gallery-item';

export const GalleryPage = ({
  items,
  onItemClicked,
  className,
}: GalleryPageProps) => {
  return (
    <div className={`${styles.galleryPage} ${className}`}>
      {items.map((item, index) => (
        <GalleryItem
          onItemClicked={(item) => {
            onItemClicked?.(item, index);
          }}
          key={item.id}
          item={item}
        />
      ))}
    </div>
  );
};
